'use client';

import { Conditional, useBreakpoint } from '@cat-ecom/pcc-components';
import { CatButton, CatHeading } from 'components/blocks-components';
import { PRODUCT_LIST_LIMIT } from '../../constants';
import { VIEWALL_GAEVENTS } from '../constants';
import { useTranslations } from 'next-intl';
import { PAGE_BREAKPOINTS } from 'constants/common';

export const RecentlyViewedHeading = ({
  productTotalCount,
  viewAllURL
}: Readonly<{
  productTotalCount: number;
  viewAllURL: string;
}>) => {
  const t = useTranslations();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const buttonSize = isLG ? 'md' : 'lg';

  const handleRedirectUrl = () => {
    window.location.href = viewAllURL;
  };

  return (
    <div className="d-flex justify-content-between align-items-center px-0 pt-0 py-1 p-blg-3">
      <CatHeading variant="title-sm">{t('RECENTLY_VIEWED')}</CatHeading>
      <Conditional test={productTotalCount > PRODUCT_LIST_LIMIT}>
        <CatButton
          variant="inline"
          size={buttonSize}
          onClick={handleRedirectUrl}
          data-track-event={VIEWALL_GAEVENTS.PRIMARY_CTA}
          data-track-attr-nltext={VIEWALL_GAEVENTS.BUTTON_EVENT_NAME}
          data-track-attr-context={VIEWALL_GAEVENTS.CONTEXT}
        >
          {t('VIEW_ALL')} {`(${productTotalCount})`}
        </CatButton>
      </Conditional>
    </div>
  );
};
